module.exports = {
          srcSet: __webpack_public_path__ + "d7bf4892.png"+" 45w",
          images:[ {path: __webpack_public_path__ + "d7bf4892.png",width: 45,height: 45}],
          src: __webpack_public_path__ + "d7bf4892.png",
          toString:function(){return __webpack_public_path__ + "d7bf4892.png"},
          
          width: 45,
          height: 45
        }